import {VatRate} from "../../libs/enum/vat-rate.enum";
import {isDefined, isTrue} from "../../libs/utils/epic.utils";
import {BookingCategory} from "../../libs/enum/booking-category.enum";
import {ReceiptDiscountDto} from "./receipt-discount.dto";

export class ReceiptPositionDto {

  public /* readonly */ id!: string;
  public /* readonly */ pos!: number;
  public number: number | undefined;
  public quantity: number | undefined;
  public description: string | undefined;
  public netAmount: number | undefined;
  public grossAmount: number | undefined;
  public /* readonly */ vatAmount: number | undefined;
  public /* readonly */ totalNetAmount: number | undefined;
  public /* readonly */ totalGrossAmount: number | undefined;
  public /* readonly */ totalVatAmount: number | undefined;
  public priceMileageAllowance: number | undefined;
  public vatRate: VatRate | undefined;
  public vatRateValue: number | undefined;
  public individualVatRate!: boolean;
  // If 'bookingCategory' is changed, 'bookingCategoryId' must be set to 'undefined'
  public bookingCategoryId: string | undefined;
  public bookingCategory: BookingCategory | undefined;
  public discounts: ReceiptDiscountDto[] = [];
  public oldPart!: boolean;
  public /* readonly */ oldPartTotalVatAmount: number | undefined;
  public oldPartListPrice: number | undefined;

  constructor(init?: Partial<ReceiptPositionDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.discounts)) {
      this.discounts = init.discounts.map((d) => new ReceiptDiscountDto(d));
    } else {
      this.discounts = [];
    }
    if (isDefined(init?.individualVatRate)) {
      this.individualVatRate = init?.individualVatRate;
    } else {
      this.individualVatRate = false;
    }
  }

  public patch(pos: ReceiptPositionDto): void {
    this.id = pos.id;
    this.pos = pos.pos;
    this.vatAmount = pos.vatAmount;
    this.totalNetAmount = pos.totalNetAmount;
    this.totalGrossAmount = pos.totalGrossAmount;
    this.totalVatAmount = pos.totalVatAmount;
    this.vatRateValue = pos.vatRateValue;
    this.oldPart = pos.oldPart;
    this.oldPartTotalVatAmount = pos.oldPartTotalVatAmount;
    this.oldPartListPrice = pos.oldPartListPrice;
  }

  public isOldPart(): boolean {
    return isTrue(this.oldPart);
  }
}
